// Private/incognito tabs, disabled cookies and some mobile browsers (seen on
// Chrome Mobile/Android in Bugsnag) throw a SecurityError DOMException on any
// localStorage/sessionStorage access, including the property access itself
// (`window.localStorage`), not just getItem/setItem. Every read/write in the
// app must go through here instead of touching the Storage objects directly.

type StorageArea = 'localStorage' | 'sessionStorage';

const getStorage = (area: StorageArea): Storage | null => {
  if (typeof window === 'undefined') return null;
  try {
    return window[area];
  } catch (error) {
    if (error instanceof DOMException) return null;
    throw error;
  }
};

export const safeGetItem = (area: StorageArea, key: string): string | null => {
  const storage = getStorage(area);
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch (error) {
    if (error instanceof DOMException) return null;
    throw error;
  }
};

export const safeSetItem = (area: StorageArea, key: string, value: string) => {
  const storage = getStorage(area);
  if (!storage) return;
  try {
    storage.setItem(key, value);
  } catch (error) {
    if (!(error instanceof DOMException)) throw error;
  }
};

export const safeRemoveItem = (area: StorageArea, key: string) => {
  const storage = getStorage(area);
  if (!storage) return;
  try {
    storage.removeItem(key);
  } catch (error) {
    if (!(error instanceof DOMException)) throw error;
  }
};
